<div>
  <p class="mt-0 text-base font-semibold">
    ¿La gravedad del conflicto amerita una intimación?
  </p>
  <div class="flex flex-row justify-content-start align-items-center gap-2">
    <p-button
      [style]="{ background: '#263245' }"
      label="Si"
      class="sm:text-xs"
      (click)="enableButtons()"
    />
    <p-button
      label="No"
      class="btn-cancelar sm:text-xs"
      (click)="resultIntimationEvent.emit(false); enableButton = true"
    />
  </div>
  <p class="text-base font-semibold">
    Seleccione el tipo de intimación que se enviará a las partes
  </p>
  <div class="flex flex-row justify-content-start align-items-center gap-2">
    <p-button
      label="INTERVENCIÓN PREVENTIVA"
      class="type button-color sm:text-xs"
      [disabled]="enableButton"
      (click)="resultTypeEvent.emit('INTERVENCIÓN PREVENTIVA')"
    />
    <p-button
      [disabled]="enableButton"
      label="INTERVENCIÓN REPARATORIA"
      class="type button-color sm:text-xs"
      (click)="resultTypeEvent.emit('INTERVENCIÓN REPARATORIA')"
    />
  </div>
</div>
